import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/rootWx/get.do',
        method: 'post',
        params: query
    }); 
    return list;
};

//编辑
export const updateData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/rootWx/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};


export const delMemberDate = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
 
 




